module.exports = __webpack_public_path__ + "media/loader-carrying-pallet-of-boxes-in-warehouse-2022-08-10-08-26-35-utc.5d09f38c.mp4";